export enum ProductPriceType {
	PER_UNIT = 'PER_UNIT',
	PER_CHARGING_POINT = 'PER_CHARGING_POINT',
}
